/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tl_Items_CountInputs */

const en_tl_items_count = /** @type {(inputs: Tl_Items_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items`)
};

const de_tl_items_count = /** @type {(inputs: Tl_Items_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Vorgänge`)
};

/**
* | output |
* | --- |
* | "{count} items" |
*
* @param {Tl_Items_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_items_count = /** @type {((inputs: Tl_Items_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Items_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_items_count(inputs)
	return en_tl_items_count(inputs)
});